export interface CheckboxProps {}

const Checkbox: React.FC<CheckboxProps> = () => {
  return (
    <div>
      <input type="checkbox" />
    </div>
  )
}

export default Checkbox
